module.exports = __webpack_public_path__ + "static/maintenance-mobile-bg-8b4a5a622ffd63e8be04703ca889370c.svg";